/*
========= TO USE ==========
Start local server with:
npm start

Build server version:
npm run build

Then copy files to server. If changing server location, change homepage in package.json
*/
import './App.css';
//import '@nlux/themes/nova.css';
import '@nlux/themes/unstyled.css';
import './horatiotheme.css';
import { Fragment } from 'react';
import { AiChat, useAiChatApi, AiChatUI } from '@nlux/react';
import { useAsBatchAdapter, AdapterExtras } from '@nlux/react';
import { MoreInfo } from './moreinfo';

/*
NLUX INTERFACE
========================================
Read:
https://docs.nlkit.com/nlux/reference/ui/ai-chat
*/

// Choose which server to use.

// Use proxy in development to avoid CORS issues, full URL in production
const apiEndPoint = process.env.NODE_ENV === 'development' 
  ? '/horatiofactsheets' // Uses proxy in package.json for local development
  : 'https://horatioserver-771404968465.europe-west2.run.app/horatiofactsheets'; // Google cloud run

// Log the endpoint being used for debugging
if (process.env.NODE_ENV === 'development') {
  console.log('Using API endpoint:', apiEndPoint);
  console.log('Proxy configured in package.json should forward to: https://horatioserver-771404968465.europe-west2.run.app');
}

// Alternative endpoints (uncomment to use):
//const apiEndPoint = 'http://localhost:5000/horatiofactsheets'; // local factsheets
//const apiEndPoint   = 'https://horatioserver.azurewebsites.net/horatiofactsheets'; // server factsheets
//const apiEndPoint = 'http://localhost:5000/horatio'; // local funds AIQ
//const apiEndPoint = 'https://server.horatio.ai/horatio'; // Heroku
//const apiEndPoint = 'https://horatioserver.azurewebsites.net/horatio'; //Azure

const batchText = (message, extras) => {
  console.log('Making request to:', apiEndPoint);
  return fetch(apiEndPoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "message": message,
      "conversationHistory": extras.conversationHistory
    })
  })
    .then(response => {
      console.log('Response status:', response.status, response.statusText);
      if (!response.ok) {
        // Try to get error message from response
        return response.text().then(text => {
          let errorMsg = `Server error: ${response.status} ${response.statusText}`;
          try {
            const json = JSON.parse(text);
            if (json.error || json.message) {
              errorMsg += ` - ${json.error || json.message}`;
            }
          } catch (e) {
            if (text) errorMsg += ` - ${text.substring(0, 100)}`;
          }
          throw new Error(errorMsg);
        });
      }
      return response.json();
    })
    .then(json => {
      if (json && json.message) {
        return json.message;
      }
      // Handle case where response might be different format
      return json || 'No response from server';
    })
    .catch(error => {
      console.error('API Error:', error);
      return `Error: ${error.message}. Please check if the server is running and accessible.`;
    });
};

/*

[nlux] API object passed was is not compatible with AiChat.
Only use API objects created by the useAiChatApi() hook.
*/

function App() {

  const adapter = useAsBatchAdapter(batchText, []);
  // Use the AiChat API reference to pass to <AiChat />
  const api = useAiChatApi();

  return (
    <Fragment>
      <div className="App">
        <AiChat
          displayOptions={{ themeId: 'horatio' }}
          adapter={adapter}
          api={api}
          composerOptions={{
            placeholder: 'Ask Horatio'
          }}
          conversationOptions={{
            conversationStarters: [
              {label:"Inspire Me",
                prompt: 'I am considering investing in 3 funds : the Schroder corporate bond fund GB0009569657, the L&G global equity fund GB00BGYBX458 and the Schroder Asia Alpha Plus fund GB00B284G093. Create me a table that compares and contrasts the risk facts for investing in these 3 funds.'},
              {label:"Fact Checking",
                prompt: 'Review the following sentance, and tell me of any factual errors: The GAIA BlueTrend fund is managed by Leda Braga and Andy Smith. It is primarily invested in Europe.'},
              {label:"Comparison",
                prompt:'Compare how the top 10 holdings of the Schroder European Sustainable Equity Fund has changed between June 2024 and December 2024. Show in a single table.'
              }
            ]
          }}
        >
          <AiChatUI.Greeting>
            <Fragment>
              <span className="rounded" style={{lineHeight: '1.5'}}><img width="144px" height="144px" src="/horatio-logo-square-2.png" alt="Horatio Logo" /></span>
              <span className="rounded" style={{lineHeight: '1.5'}}><h1 className="welcome">Hi, I'm Horatio</h1></span>
              <span className="rounded" style={{lineHeight: '1.5'}}>Horatio is an AI assistant with knowledge of UK funds.</span>
            </Fragment>
          </AiChatUI.Greeting>
        </AiChat>
      </div> 
      <div style={{ textAlign: 'center', lineHeight: '1.5', fontSize: '13px' }}>Horatio does make mistakes. Always double-check.<MoreInfo /></div>
    </Fragment>
  );
}


/*

REWRITETHIS TO CREATE AS NEW FILE

Create a button/link at the bottom right of the page , after the words "double-check". Label of button is "More Info". Clicking on the button opens a popup that fills most of the screen (must do this on desktop and mobile), and the contents of the pop-up is a dsecription of the app. There is a close button on the pop-up to hide the More Info box,

*/

export default App;

